import { useTranslation } from "react-i18next";

const SPELL_LEVELS = Array.from({ length: 10 }, (_, level) => level);

const SpellLevelSummary = ({ levels = [], onChange }) => {
  const { t } = useTranslation();
  const levelData = (level) =>
    levels.find((entry) => entry.level === level) ?? {
      level,
      known: 0,
      perDay: 0,
      cast: 0,
      bonus: 0,
      saveDc: 0,
    };

  const update = (level, key, value) => {
    onChange(
      levels.map((entry) =>
        entry.level === level
          ? { ...entry, [key]: Math.max(0, Number(value) || 0) }
          : entry
      )
    );
  };

  return (
    <section className="spell-level-summary">
      <h2>{t("spells.title")}</h2>
      <div className="spell-level-summary-grid spell-level-summary-header">
        <span>{t("spells.known")}</span>
        <span>{t("spells.perDay")}</span>
        <span>{t("spells.level")}</span>
        <span>{t("spells.cast")}</span>
        <span>{t("spells.bonus")}</span>
        <span>{t("spells.saveDc")}</span>
      </div>
      {SPELL_LEVELS.map((level) => {
        const entry = levelData(level);
        return (
          <div className="spell-level-summary-grid" key={level}>
            <input aria-label={t("spells.levelKnown", { level })} min="0" type="number" value={entry.known} onChange={(event) => update(level, "known", event.target.value)} />
            <input aria-label={t("spells.levelPerDay", { level })} min="0" type="number" value={entry.perDay} onChange={(event) => update(level, "perDay", event.target.value)} />
            <strong>{level}</strong>
            <input aria-label={t("spells.levelCast", { level })} min="0" type="number" value={entry.cast} onChange={(event) => update(level, "cast", event.target.value)} />
            <input aria-label={t("spells.levelBonus", { level })} min="0" type="number" value={entry.bonus} onChange={(event) => update(level, "bonus", event.target.value)} />
            <input aria-label={t("spells.levelSaveDc", { level })} min="0" type="number" value={entry.saveDc} onChange={(event) => update(level, "saveDc", event.target.value)} />
          </div>
        );
      })}
    </section>
  );
};

export default SpellLevelSummary;
